var render = function render(){var _vm=this,_c=_vm._self._c;return _c('df-app',{attrs:{"title":"Tools"}},[_c('df-solutions',{attrs:{"filterable":"","solutions":_vm.solutions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }